import { PLATFORMS } from '../common/utilities/constants.js'
import PostMedia from './PostMedia.js'
import { postTime } from '../common/utilities/localizedPostTime.js'

class Post {
  constructor(rawPost) {
    /* Since we're working schemaless these keys can differ from posts.
     * Looping makes more sense here.
     * This keep will keep the same interface as well as the post object
     */
    Object.keys(rawPost).forEach((key) => {
      if (key === 'productKeys') {
        const rawValue = rawPost[key]
        this.rawProductKeys = typeof rawValue === 'string' ? JSON.parse(rawValue) : rawValue
      } else if (key === 'media') {
        this.rawMedia = (rawPost[key] || []).map((m) => new PostMedia(m))
      } else if (key === 'text') {
        this.rawText = rawPost[key]
      } else {
        this[key] = rawPost[key]
      }
    })
  }

  get text() {
    return this.rawText
  }

  get characterCount() {
    const text = this.text || ''
    return text.length
  }

  get productKeys() {
    return this.rawProductKeys || []
  }

  get media() {
    return this.rawMedia || []
  }

  getMediaFromIndex(index) {
    const media = this.media[index]
    return media || new PostMedia({})
  }

  get hasProducts() {
    return this.rawProductKeys && !!this.rawProductKeys.length
  }

  get hasMedia() {
    return this.media && this.media.length > 0
  }

  get isCarouselPost() {
    return this.media.length > 1
  }

  get hasVideo() {
    return this.hasMedia && this.media.some((mediaItem) => mediaItem.isVideo)
  }

  get isYoutubePost() {
    return this.sourceName === PLATFORMS.YOUTUBE
  }

  get isTikTokPost() {
    return this.sourceName === PLATFORMS.TIKTOK || this.sourceName === PLATFORMS.TIKTOK_BUSINESS
  }

  get thumbnailMedia() {
    return this.media.find((mediaItem) => mediaItem.thumbnail) || null
  }

  get thumbnailMediaPosition() {
    const mediaPosition = this.media.findIndex((mediaItem) => mediaItem.thumbnail)
    return mediaPosition === -1 ? 0 : mediaPosition
  }

  getIsVideoPost(index = null) {
    if (index !== null) {
      return this.media[index].isVideo
    }
    const mediaWithThumbnail = this.thumbnailMedia
    if (mediaWithThumbnail) {
      return mediaWithThumbnail.isVideo
    }
    return this.media[0]?.isVideo
  }

  getRenderImage(mediaIndex = 0) {
    let { thumbnail } = this // post instance

    if (!thumbnail && mediaIndex === 0) {
      return null
    }

    if (mediaIndex !== 0) {
      thumbnail = this.media[mediaIndex]
    }

    if (!thumbnail.url) {
      if (!thumbnail.fallbackUrl) {
        return null
      }
      return thumbnail.fallbackUrl
    }
    return thumbnail.url
  }

  get lines() {
    return this.text.split(/\n/)
  }

  setIndex(index) {
    this.index = index
  }

  getAriaLabel(mediaIndex, locale, isVideo = false) {
    if (
      this.altText &&
      mediaIndex > -1 &&
      locale?.language &&
      locale.getTranslation('mediaAltText')
    ) {
      return locale.getTranslation('mediaAltText')(
        isVideo,
        this.userName,
        postTime(this.publishedAt, locale),
        this.altText?.[mediaIndex]?.[locale.language],
      )
    }
    return undefined
  }
}

export default Post
